import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef, DoCheck } from '@angular/core';
import { getForm } from './review-comment.element';
import { Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { IDFormControl } from '../../d-form/d-form.helpers';
@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'app-review-comments',
	templateUrl: './review-comments.component.html',
	styleUrls: ['./review-comments.component.css']
})
export class ReviewCommentsComponent implements OnInit, DoCheck {
	formArray: any = [];
	@Input() reviewComments: any;
	@Input() reviewCommentsLabel: any = 'Reviews Comments';
	@Input() withoutSubmit: boolean;
	@Input() withoutCancel: boolean;
	@Input() disable: any;
	@Input() reviewCommentsOptions: any;
	@Output() submit = new EventEmitter();
	@Output() cancel = new EventEmitter();
	@Input() exceptComment: any = [];
	@Input() dependentValidities: any = [];
	control: IDFormControl;
	@Output() reviewControl = new EventEmitter();
	view: any;
	constructor(private route: ActivatedRoute, private cdr: ChangeDetectorRef) {

	}

	onSubmit(data) {
		this.submit.emit(data);
	}

	onCancel(data) {
		this.cancel.emit(data);
	}

	onControlChange(control) {
		this.control = control;
		this.reviewControl.emit(control);
	}

	ngOnInit() {
		this.route.queryParams.subscribe(params => {
			this.view = params['view'];

		});

		this.formArray = getForm(
			{
				reviewCommentsOptions: this.reviewCommentsOptions,
				reviewCommentsLabel: this.reviewCommentsLabel
			},
			{
				reviewChanges: this.onReviewChange.bind(this)
			},
			{
				withoutSubmit: this.withoutSubmit,
				withoutCancel: this.withoutCancel
			}
			// this.view
		);
	}


	onReviewChange(review) {
		this.formArray.forms[0].formRef.controls.comment.markAsDirty();
		this.formArray.forms[0].formRef.controls.comment.markAsTouched();
		if (this.exceptComment.indexOf(review) >= 0 || this.disable) {
			this.formArray.forms[0].formRef.controls.comment.clearValidators();
			this.formArray.forms[0].formRef.controls.comment.updateValueAndValidity();
		} else {
			const commentValidators = [Validators.required];
			this.formArray.forms[0].formRef.controls.comment.setValidators(
				commentValidators
			);
			this.formArray.forms[0].formRef.controls.comment.updateValueAndValidity();
		}
	}

	ngDoCheck() {
		this.cdr.detectChanges();
	}
}
